import PeriodicosExamDrawer from './PeriodicosExamDrawer';
import PeriodicosPrestadorDrawer from './PeriodicosPrestadorDrawer';
import { DrawerContainer } from '../../../components/Drawer/DrawerContainer';
import PeriodicosGenerateConvocatoriaDrawer from './PeriodicosGenerateConvocatoriaDrawer';
import PeriodicosAsignarTurnoDrawer from './PeriodicosAsignarTurnoDrawer';
import PeriodicosExamAndPrestadorDrawer from './PeriodicosExamAndPrestadorDrawer';
import PeriodicosAsignarResultadoDrawer from './PeriodicosAsignarResultadoDrawer';

export const PERIODICOS_DRAWER_ACTION_VALUES = {
    ASSIGN_EXAM: 'assign-exam',
    ASSIGN_PRESTADOR: 'assign-prestador',
    GENERATE_CONVOCATORIA: 'generate-convocatoria',
    ASSIGN_SHIFT: 'assign-shift',
    ASSIGN_EXAM_AND_PRESTADOR: 'assign-exam-and-prestador',
    ASSIGN_RESULTS: 'generate-results',
    GENERATE_CONVOCATED: 'generate-convocated',
    SEE_CONVOCATED: 'see-convocated'
};

interface PeriodicosDrawerManagerProps {
    open: string;
    setOpen: (state: string) => void;
    selectedIds: string[];
    reloadGrid: () => void;
    selectedEmployee?: {
        nombre?: string;
        riesgo?: { id: number; codigo: any } | { id: number; codigo: any }[];
    };
    reloadCurrentTab: () => void;
    tabIndex: number;
}
const PeriodicosDrawerManager = ({
    open,
    setOpen,
    selectedIds,
    reloadGrid,
    selectedEmployee,
    reloadCurrentTab,
    tabIndex
}: PeriodicosDrawerManagerProps) => {
    const employeeRisk = Array.isArray(selectedEmployee?.riesgo)
        ? selectedEmployee?.riesgo.map((r) => r.codigo).join(', ')
        : selectedEmployee?.riesgo?.codigo || '';

    const handleCloseDrawer = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        setOpen('');
    };

    const renderDrawerContent = () => {
        switch (open) {
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_EXAM:
                return (
                    <PeriodicosExamDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_PRESTADOR:
                return (
                    <PeriodicosPrestadorDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                        employeeName={selectedEmployee?.nombre || ''}
                        employeeRisk={employeeRisk}
                        selectedEmployee={selectedEmployee}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.GENERATE_CONVOCATORIA:
                return (
                    <PeriodicosGenerateConvocatoriaDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_SHIFT:
                return (
                    <PeriodicosAsignarTurnoDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                        selectedEmployee={selectedEmployee}
                        reloadCurrentTab={reloadCurrentTab}
                        tabIndex={tabIndex}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_RESULTS:
                return (
                    <PeriodicosAsignarResultadoDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                        selectedEmployee={selectedEmployee}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_EXAM_AND_PRESTADOR:
                return (
                    <PeriodicosExamAndPrestadorDrawer
                        setOpen={handleCloseDrawer}
                        employeeName={selectedEmployee?.nombre || ''}
                        employeeRisk={employeeRisk}
                        selectedEmployee={selectedEmployee}
                        reloadGrid={reloadGrid}
                    />
                );

            default:
                return <></>;
        }
    };

    return (
        <DrawerContainer open={!!open} setOpen={setOpen} customWidth={480}>
            {renderDrawerContent()}
        </DrawerContainer>
    );
};

export default PeriodicosDrawerManager;
